import { render, staticRenderFns } from "./SpikyBallDashboardItem.vue?vue&type=template&id=095ff648&scoped=true"
import script from "./SpikyBallDashboardItem.vue?vue&type=script&lang=js"
export * from "./SpikyBallDashboardItem.vue?vue&type=script&lang=js"
import style0 from "./SpikyBallDashboardItem.vue?vue&type=style&index=0&id=095ff648&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "095ff648",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/buildhome/repo/admin-ui/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('095ff648')) {
      api.createRecord('095ff648', component.options)
    } else {
      api.reload('095ff648', component.options)
    }
    module.hot.accept("./SpikyBallDashboardItem.vue?vue&type=template&id=095ff648&scoped=true", function () {
      api.rerender('095ff648', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/Dashboard/Items/SpikyBallDashboardItem.vue"
export default component.exports